/* LQK Quran Adventure — journey up the map through 8 Quran stories.
   Each level: a story question + a mini huruf hunt. Progress persists in
   localStorage only. Depends on lqk-games-kit.js */
(function () {
  'use strict';
  var root = document.querySelector('[data-lqkg-adventure]');
  if (!root || !window.LQKG) return;
  var K = window.LQKG;

  var STORE_KEY = 'lqkg-adventure';

  /* look-alike pools for the mini letter hunt */
  var FAMILY = {
    'ي': ['ب', 'ت', 'ث', 'ن'], 'ك': ['ل', 'ا', 'م', 'ه'], 'ن': ['ب', 'ت', 'ث', 'ي'],
    'م': ['ه', 'و', 'ق', 'ف'], 'س': ['ش', 'ص', 'ض', 'ن'], 'ع': ['غ', 'ح', 'خ', 'ج'],
    'ف': ['ق', 'غ', 'و', 'م'], 'ص': ['ض', 'س', 'ش', 'ط']
  };

  var LEVELS = [
    { title: 'Yunus (AS) and the Whale', x: 47, y: 90, letter: 'ي', letterName: 'ya — for Yunus',
      story: 'Nabi Yunus (AS) was swallowed by a huge whale. In the darkness he kept praying to Allah, and Allah saved him.',
      q: 'Where did Nabi Yunus (AS) make his special dua?',
      options: ['Inside the whale', 'On a mountain', 'In a palace'], answer: 0 },
    { title: 'Ibrahim (AS) builds the Kaaba', x: 21, y: 73, letter: 'ك', letterName: 'kaf — for Kaaba',
      story: 'In the desert valley of Makkah, Nabi Ibrahim (AS) raised the walls of the Kaaba, making dua as he built.',
      q: 'Who helped Nabi Ibrahim (AS) build the Kaaba?',
      options: ['His son Ismail', 'His neighbour', 'A caravan of traders'], answer: 0 },
    { title: 'Nuh (AS) and the Ark', x: 78, y: 76, letter: 'ن', letterName: 'nun — for Nuh',
      story: 'Nabi Nuh (AS) built a great ark, and the animals came aboard two by two before the great flood.',
      q: 'How did the animals enter the ark?',
      options: ['In pairs', 'One by one', 'All in one big herd'], answer: 0 },
    { title: 'Musa (AS) and the Sea', x: 24, y: 52, letter: 'م', letterName: 'mim — for Musa',
      story: 'Trapped by Firaun’s army at the sea, Nabi Musa (AS) struck the water with his staff by Allah’s command.',
      q: 'What happened to the sea?',
      options: ['It split open into a path', 'It froze solid', 'It turned to sand'], answer: 0 },
    { title: 'Sulaiman (AS) and the Ant', x: 67, y: 48, letter: 'س', letterName: 'sin — for Sulaiman',
      story: 'Nabi Sulaiman (AS) could understand animals. One day he smiled when he heard a tiny ant warning her friends.',
      q: 'What did the little ant tell the other ants?',
      options: ['Go into your homes', 'Collect more food', 'Climb the trees'], answer: 0 },
    { title: 'The Cave of Thawr', x: 78, y: 33, letter: 'ع', letterName: 'ain — for ankabut (spider)',
      story: 'When the Prophet صلى الله عليه وسلم and Abu Bakr (RA) hid in a cave, Allah protected them.',
      q: 'What covered the cave entrance?',
      options: ['A spider’s web', 'A wooden door', 'A waterfall'], answer: 0 },
    { title: 'The Year of the Elephant', x: 25, y: 27, letter: 'ف', letterName: 'fa — for fil (elephant)',
      story: 'Abraha marched a mighty elephant army to destroy the Kaaba, but Allah stopped them.',
      q: 'What did Allah send against the elephant army?',
      options: ['Flocks of little birds', 'A giant wave', 'A thunderstorm'], answer: 0 },
    { title: 'Isra and Mi’raj', x: 49, y: 10, letter: 'ص', letterName: 'sad — for salah',
      story: 'In one amazing night, the Prophet صلى الله عليه وسلم journeyed to Al-Aqsa and up through the heavens.',
      q: 'What gift did he bring back for all Muslims?',
      options: ['The five daily prayers', 'A chest of gold', 'A flying carpet'], answer: 0 }
  ];

  var mapEl = root.querySelector('[data-map]');
  var panel = root.querySelector('[data-panel]');
  var kicker = panel.querySelector('[data-kicker]');
  var titleEl = panel.querySelector('[data-title]');
  var storyEl = panel.querySelector('[data-story]');
  var taskEl = panel.querySelector('[data-task]');
  var bodyEl = panel.querySelector('[data-body]');
  var actionsEl = panel.querySelector('[data-actions]');
  var progressChip = root.querySelector('[data-progress]');
  var starsChip = root.querySelector('[data-starcount]');
  K.soundButton(root.querySelector('[data-sound]'));
  var modal = K.modal();

  function load() {
    try { return JSON.parse(localStorage.getItem(STORE_KEY)) || {}; } catch (e) { return {}; }
  }
  function save() {
    try { localStorage.setItem(STORE_KEY, JSON.stringify(state)); } catch (e) {}
  }
  var state = load();
  state.unlocked = state.unlocked || 1;      /* 1-based count of playable levels */
  state.stars = state.stars || {};

  var current = null, mistakes = 0;

  /* --- map rendering --- */
  function renderMap() {
    mapEl.querySelectorAll('.lqkg-adv__node').forEach(function (n) { n.remove(); });
    var totalStars = 0;
    LEVELS.forEach(function (lv, i) {
      var n = i + 1;
      var starCount = state.stars[n] || 0;
      totalStars += starCount;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'lqkg-adv__node';
      btn.style.left = lv.x + '%';
      btn.style.top = lv.y + '%';
      var stateName = n < state.unlocked ? 'done' : n === state.unlocked ? 'next' : 'locked';
      btn.setAttribute('data-state', stateName);
      btn.setAttribute('aria-label', 'Level ' + n + ': ' + lv.title + (stateName === 'locked' ? ' (locked)' : ''));
      btn.innerHTML = stateName === 'locked'
        ? '🔒'
        : n + (starCount ? '<span class="lqkg-adv__node-stars">' + '★'.repeat(starCount) + '</span>' : '');
      if (stateName !== 'locked') {
        btn.addEventListener('click', function () { openLevel(i); });
      }
      mapEl.appendChild(btn);
    });
    progressChip.textContent = Math.min(state.unlocked - 1, LEVELS.length) + '/' + LEVELS.length;
    starsChip.textContent = totalStars;
  }

  /* --- level flow: question → letter hunt → done --- */
  function openLevel(i) {
    current = i;
    mistakes = 0;
    var lv = LEVELS[i];
    panel.hidden = false;
    kicker.textContent = 'Level ' + (i + 1) + ' of ' + LEVELS.length;
    titleEl.textContent = lv.title;
    storyEl.textContent = lv.story;
    showQuestion();
    requestAnimationFrame(function () { requestAnimationFrame(function () { panel.classList.add('is-in'); }); });
    panel.scrollIntoView({ behavior: K.reducedMotion ? 'auto' : 'smooth', block: 'nearest' });
    K.sound.tap();
  }

  function showQuestion() {
    var lv = LEVELS[current];
    taskEl.textContent = lv.q;
    actionsEl.innerHTML = '';
    bodyEl.innerHTML = '<div class="lqkg-adv__options"></div>';
    var wrap = bodyEl.firstChild;
    var opts = lv.options.map(function (t, j) { return { t: t, correct: j === lv.answer }; });
    K.shuffle(opts).forEach(function (o) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'lqkg-adv__option';
      btn.textContent = o.t;
      btn.addEventListener('click', function () {
        if (o.correct) {
          btn.classList.add('is-correct');
          wrap.querySelectorAll('button').forEach(function (b) { b.disabled = true; });
          K.sound.ding();
          K.vibrate(20);
          setTimeout(showHunt, 800);
        } else {
          mistakes++;
          btn.disabled = true;
          btn.classList.add('is-wrong');
          K.sound.buzz();
        }
      });
      wrap.appendChild(btn);
    });
  }

  function showHunt() {
    var lv = LEVELS[current];
    taskEl.innerHTML = 'Now find 3 × <span style="font-family:Amiri,serif;font-size:1.5em">' + lv.letter + '</span> (' + lv.letterName + ')';
    bodyEl.innerHTML = '<div class="lqkg-adv__grid"></div>';
    var grid = bodyEl.firstChild;
    var pool = [lv.letter, lv.letter, lv.letter];
    var fam = FAMILY[lv.letter];
    while (pool.length < 16) pool.push(fam[Math.floor(Math.random() * fam.length)]);
    var found = 0;
    K.shuffle(pool).forEach(function (letter) {
      var cell = document.createElement('button');
      cell.type = 'button';
      cell.className = 'lqkg-adv__cell';
      cell.textContent = letter;
      cell.addEventListener('click', function () {
        if (cell.classList.contains('is-found')) return;
        if (letter === lv.letter) {
          cell.classList.add('is-found');
          K.sound.ding();
          K.vibrate(15);
          if (++found === 3) setTimeout(levelDone, 600);
        } else {
          mistakes++;
          cell.classList.remove('is-wrong');
          void cell.offsetWidth;
          cell.classList.add('is-wrong');
          K.sound.buzz();
        }
      });
      grid.appendChild(cell);
    });
  }

  function levelDone() {
    var n = current + 1;
    var stars = Math.max(1, 3 - mistakes);
    state.stars[n] = Math.max(state.stars[n] || 0, stars);
    if (n === state.unlocked) state.unlocked = Math.min(LEVELS.length + 1, state.unlocked + 1);
    save();
    renderMap();
    closePanel();
    var finished = state.unlocked > LEVELS.length;
    K.sound.win();
    K.confetti();
    modal.show({
      title: finished && n === LEVELS.length ? 'You completed the whole journey!' : 'Level ' + n + ' complete!',
      text: finished && n === LEVELS.length
        ? 'MashaAllah! You travelled through all 8 stories of the Quran adventure.'
        : '⭐'.repeat(stars) + ' · ' + LEVELS[current].title,
      stars: stars,
      againLabel: finished && n === LEVELS.length ? 'Back to the map' : 'Continue',
      onAgain: function () {
        if (state.unlocked <= LEVELS.length) openLevel(state.unlocked - 1);
      }
    });
  }

  function closePanel() {
    panel.classList.remove('is-in');
    panel.hidden = true;
  }
  panel.querySelector('[data-close]').addEventListener('click', function () { closePanel(); K.sound.tap(); });

  renderMap();
})();
